<template>
  <div>
    <a-toolbar class="primary-gradient pl-4">
      <v-icon left dark> mdi-label-variant </v-icon
      ><span class="widget-title">{{ getTitle(widgetData.widgetType) }}</span>
    </a-toolbar>
    <v-skeleton-loader
      v-if="isSkeleton"
      type="table-row, table-row, table-row, table-row, table-row, table-row, table-row, table-row"
      class="pa-8"
    ></v-skeleton-loader>
    <v-simple-table
      class="people-table overflow-y-auto"
      v-else
      flat
      fixed-header
    >
      <template v-slot:default>
        <thead class="v-data-table-header">
          <tr>
            <th
              v-for="header in headers"
              :key="header.id"
              :class="
                header.value === 'people'
                  ? 'text-left th-header'
                  : 'text-center th-header'
              "
              :id="header.id"
            >
              {{ header.name }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="people in peopleFilterList" :key="people.id">
            <td
              v-for="header in headers"
              :key="header.id"
              :class="
                header.value === 'people' ? 'text-left' : 'text-center cell'
              "
            >
              <router-link
                v-if="header.value === 'people'"
                class="mt-2"
                style="cursor: pointer; display: inline-flex"
                :to="`/people/${people.id}/tenant/${selectedTenant}/dashboard`"
              >
                <v-img
                  v-if="people.profilePhoto"
                  :src="people.profilePhoto"
                  height="40"
                  width="40"
                  class="mr-2"
                  contain
                ></v-img>
                <v-img
                  v-else
                  height="40"
                  width="40"
                  class="mr-2"
                  contain
                  src="@/assets/images/No-Photo.jpg"
                ></v-img>
                <h3>{{ people[header.value] || "not found" }}</h3></router-link
              >
              <v-tooltip bottom v-else-if="people[header.value]">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    size="25"
                    v-on="on"
                    v-bind="attrs"
                    dense
                    color="primary"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                </template>
                {{ header.name }}
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";
import { createUUID } from "../../utils/util";
import AToolbar from "../../wrapper-component/AToolbar.vue";

export default {
  name: "MatrixView",
  components: {
    AToolbar,
  },
  props: {
    widgetData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isSkeleton: true,
    };
  },
  computed: {
    ...mapGetters({
      tenantSettingTypes: "tenant/tenantSettingTypes",
      getSortedUserList: "people/getSortedUserList",
    }),
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    headers() {
      if (this.widgetData.widgetType == "skillmatrix") {
        return this.skillsHeaders;
      } else {
        return this.personalityTypesHeaders;
      }
    },
    skillsHeaders() {
      let list = this.tenantSettingTypes("skills").map((skill) => {
        return {
          id: createUUID(),
          name: skill.name,
          value: skill.value,
        };
      });
      list.unshift({
        id: createUUID(),
        name: "People",
        value: "people",
      });
      return list;
    },
    peopleFilterList() {
      const list = this.getSortedUserList.map((peopleObj) => {
        return {
          id: peopleObj.id,
          profilePhoto: peopleObj.profilePhoto || null,
          people: peopleObj.firstName
            ? peopleObj.firstName + " " + peopleObj.lastName
            : peopleObj.display_email
            ? peopleObj.display_email
            : peopleObj.registered_email,
          // personalityType: peopleObj.personalityType || "",
          ...arrayToObject([peopleObj.personalityType] || []),
          skills: peopleObj.skills || [],
          ...arrayToObject(peopleObj.skills || []),
        };
      });
      return list;
    },
    personalityTypesHeaders() {
      let list = this.tenantSettingTypes("personalityTypes").map((pt) => {
        return {
          id: createUUID(),
          name: pt.name,
          value: pt.value,
        };
      });

      list.unshift({
        id: createUUID(),
        name: "People",
        value: "people",
      });
      return list;
    },
  },
  async mounted() {
    this.getDefaultOrder();
    setTimeout(() => {
      const childCard = document.getElementsByClassName("people-table");
      if (childCard && childCard.length > 0) {
        const height = childCard[0].parentElement.parentElement.offsetHeight;
        if (height) {
          childCard[0].style.height = `${height - 48}px`;
        }
      }
    }, 500);
    this.isSkeleton = false;
  },
  methods: {
    ...mapActions({
      setPeopleOrder: "people/setPeopleOrder",
    }),
    getTitle(key) {
      return this.$t(`widget.${key}`);
    },
    async getDefaultOrder() {
      const peoplelistorder = this.tenantSettingTypes("peoplelistorder");
      if (peoplelistorder.length > 0) {
        this.setPeopleOrder(peoplelistorder);
      }
    },
  },
};

function arrayToObject(arr) {
  let obj = {};
  for (let i = 0; i < arr.length; ++i) {
    obj[arr[i]] = arr[i];
  }
  return obj;
}
</script>

<style scoped>
.v-data-table-header {
  background-color: var(--v-primaryLight1-base);
}
.theme--light.people-table.v-data-table--fixed-header thead th {
  background-color: var(--v-primaryLight1-base);
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.12);
}

.th-header {
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.375rem;
  letter-spacing: 0.0071428571em;
  color: black !important;
  border-left: solid 1px lightgray !important;
}

.e-grid .e-headercell {
  background-color: gray;
}

.e-headercell {
  color: white;
  font-size: 1.5rem;
  font-weight: bold;
}
.cell {
  border-left: solid 1px lightgray !important;
}
/* table > tbody > tr > td:nth-child(1),
table > thead > tr > th:nth-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 0;
  z-index: 9998;
}
table > thead > tr > th:nth-child(1) {
  z-index: 9999;
} */
</style>